import React from 'react';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../../styles/carousel.css';


export default function Coding() {

    return (
        <div>
            <div className="content">
                <h1>I'm a Full-Stack Engineer!</h1>
                <p>I like to think that I'm not just a software developer. As an engineer, I like solving challenging problems, specially if they are fun. I like to go back to my robotics days in school and play with Arduino. When I can, I like exploring new technologies, not becuase I have to, but because I would like to have a tool ready to use when the problem requires it. </p>
                <div className="bullets">
                    In the back-end:
                    <ul>
                        <li>Java</li>
                        <li>Python</li>
                        <li>C#</li>
                    </ul>
                </div>
                <div className="bullets">
                    In the front-end:
                    <ul>
                        <li>React</li>
                        <li>Angular</li>
                        <li>Polymer</li>
                        <li>Node</li>
                    </ul>
                </div>
            </div>
        </div>
    );

}


// WEBPACK FOOTER //
// ./src/components/sections/Coding.jsx